export default __webpack_public_path__ + "static/media/galaxis_swirl_only_white.9788a546.svg";